<div class="settings-migrate-workflow-shell">
  <router-outlet></router-outlet>
</div>
